// extracted by mini-css-extract-plugin
module.exports = {"text":"_e89ffc6"};